<template>
	<div class="relativeclass">
		<header class="cvs-header">
			<div
				class="d-flex align-items-center gap-2"
				:class="$route.query.type == 'screenRec' ? ' cvs-head-width' : ''"
			>
				<img
					src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/Hire3xAssests/Logo/SVG/Hire3xbeta_logo.svg"
					alt=""
				/>
				<div class="cvs-vertical-line"></div>
				<span class="cvs-black-txt">{{
					$route.query.type == "screenRec"
						? "CVS"
						: "Candidate Verification & Screening"
				}}</span>
			</div>
			<div
				class="d-flex align-items-center gap-2 cvs-button-width justify-content-end"
				v-if="$route.query.type == 'screenRec'"
			>
				<span
					:class="timerAnimate ? 'slide-in-from-right-2' : ''"
					class="cvs-timer"
					>{{ remainingTime }}</span
				>
				<div class="position-relative">
					<b-button
						:class="isButtonDisabled ? 'opac-5' : 'pointer'"
						class="candash-addBtn-ats"
						:disabled="!isAllAnswered || isButtonDisabled"
						@click="submitAnswer"
						>Submit</b-button
					>
					<!-- <div v-if="isButtonDisabled" class="loader-pos-new">
						<Loader />
					</div> -->
				</div>
			</div>
		</header>
		<InternetCheck
			v-if="!internetCheck && $route.query.uuid && !loader && !isSubmitted"
			@internet-checked="internetCheck = true"
		/>
		<b-container
			v-else-if="!loadPreChecking && !loader && !isSubmitted"
			class="cvs-container"
		>
			<main
				class="cvs-image-cont"
				:class="
					$route.query.type != 'screenRec' ? 'mob-closedBasic-height' : ''
				"
			>
				<div
					v-if="
						$route.query.type != 'screenRec' && $route.query.type != 'submitted'
					"
					class="d-flex-class gap-3 mt-4"
					id="hideinmobile"
				>
					<img
						style="height: 50px"
						src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/Hire3x_Website_Header.svg"
						alt=""
					/>
					<div class="cvs-vertical-line-2"></div>
					<span class="cvs-black-txt-2"
						>Candidate Verification & Screening</span
					>
				</div>
				<template v-if="$route.query.type === 'imageCapture'">
					<ImageCapture @go-to-screen-rec="goToScreenRec" />
				</template>
				<template v-else-if="$route.query.type === 'screenRec'">
					<CvsRecording
						@all-answered="isAllAnswered = true"
						@start-timer="startTimer"
						@before-destroy="destroyed"
						@disableParentButton="isButtonDisabled = true"
						@pause-timer="pauseTimer"
						:remaining-time="remainingTime"
						@unlock-navigation="unlockNavigation"
					/>
				</template>

				<b-card
					v-else
					:img-src="require('@/assets/newdesign/cvs/firstDp.svg')"
					img-alt="Image"
					img-top
					class="cvs-card my-5"
				>
					<b-card-text class="text-center cvs-black-txt-3">
						Answer 5 interview question for helping us know you better.
					</b-card-text>
					<span>
						<img src="@/assets/newdesign/cvs/redInfo.svg" alt="" />Hold your ID
						card below your face and align both within the camera view.
					</span>
					<span class="mt-3">
						<img src="@/assets/newdesign/cvs/redInfo.svg" alt="" />You will have
						10 minutes to answer all the questions.
					</span>
					<b-button @click="startVerification()" class="candash-addBtn mt-3"
						>Start Verification</b-button
					>
				</b-card>
			</main>
		</b-container>
		<b-modal
			id="noRefreshModal"
			v-model="isButtonDisabled"
			no-close-on-backdrop
			centered
			hide-footer
			hide-header
		>
			<div
				class="position-relative h-100 d-flex flex-column align-items-center justify-content-center"
			>
				<Spinner id="jobmatch" />
				<div
					class="fam-lato text-lightgrey fw-LM fs-14 mob-fs-12 mt-4 text-center"
				>
					Please do not close or refresh this page while we process your data..
				</div>
			</div>
		</b-modal>

		<!-- Mic Muted Modal -->
		<b-modal
			id="micMutedModal"
			v-model="showMicMutedModal"
			no-close-on-backdrop
			no-close-on-esc
			centered
			hide-footer
			title="Microphone is Muted"
		>
			<div class="d-flex flex-column align-items-center text-center p-3">
				<img
					src="@/assets/newdesign/cvs/redInfo.svg"
					alt="mic muted"
					style="width: 48px; margin-bottom: 16px"
				/>
				<p class="fam-lato fs-16 fw-LM mb-3">
					<span v-if="micMutedMessage">{{ micMutedMessage }}</span>
					<span v-else>
						Your microphone is currently <strong>muted</strong>. Please unmute
						your microphone (or press your keyboard mute key) to continue.
					</span>
				</p>
				<b-button class="candash-addBtn mt-2" @click="unmuteAndContinue">
					Unmute &amp; Continue
				</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import ImageCapture from "@/components/Cvs/ImageCapture.vue";
import CvsRecording from "@/components/Cvs/CvsRecording.vue";
import { cvsPreCheck } from "@/utils/apiFunctions";
import EventBus from "../../utils/EventBus.js";
import { mapGetters } from "vuex";
import errorModal from "@/components/mixin/toast";
import Loader from "@/components/fixedcomponents/Loader.vue";
import "@/assets/globalcss/cvs.css";
import InternetCheck from "./InternetCheck.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
export default {
	name: "IdCapture",
	mixins: [errorModal],
	data() {
		return {
			isSubmitted: this.$route.query.uuid ? true : false,
			loader: false,
			timerAnimate: false,
			imageCapture: false,
			isActive: false,
			nextStep: false,
			firstImg: false,
			isAllAnswered: false,
			takenMsg: "",
			timer: null,
			timerInterval: null,
			// timerApiInterval: null,
			loadPreChecking: false,
			loading: false,
			isButtonDisabled: false,
			internetCheck: false,
			showMicMutedModal: false,
			micStream: null,
			micMutedMessage: "",
			micCheckInterval: null,
		};
	},
	components: {
		ImageCapture,
		CvsRecording,
		Loader,
		InternetCheck,
		Spinner,
	},
	created() {
		this.firstImg = true;
		if (this.$route.query.uuid) {
			this.loader = true;
			this.cvsPreChecking();
		}
		if (this.$route.query.type == "screenRec") {
			this.timerAnimate = true;
		}
	},
	mounted() {
		if (localStorage.getItem("cvsStarted")) {
			history.pushState(null, null, location.href); // Push trap state
			window.addEventListener("popstate", this.preventBack);
			window.addEventListener("beforeunload", this.beforeUnloadHandler);
		}
		EventBus.$on("loader-false", this.resetLoader);
	},
	beforeDestroy() {
		window.removeEventListener("popstate", this.preventBack);
		this.stopMicMuteCheckLoop();
	},
	watch: {
		remainingTimeInSeconds(value) {
			if (value <= 0) {
				EventBus.$emit("submit-answer");
			}
		},
		$route(to, from) {
			// Block navigation away from screenRec
			if (localStorage.getItem("cvsStarted")) {
				if (from.query.type === "screenRec" && to.query.type !== "screenRec") {
					this.$router.replace(from); // Force user back to screenRec
					return;
				}
			}
			// Resume existing logic
			if (to.query.type === "screenRec") {
				localStorage.setItem("cvsStarted", true);
				this.startMicMuteCheckLoop();
			} else {
				this.stopMicMuteCheckLoop();
			}
			if (this.$route.query.uuid) {
				if (this.$route.query.refresh === "true") {
					this.internetCheck = false;
				}
				localStorage.setItem("timer", 600);
				sessionStorage.clear();
				this.cvsPreChecking();
			}
		},
	},
	computed: {
		...mapGetters("servicesVUEX", {
			remainingTime: "getRemainingTime",
			remainingTimeInSeconds: "getRemainingTimeInSeconds",
		}),
	},
	beforeDestroy() {
		EventBus.$off("loader-false");
	},
	methods: {
		pauseTimer() {
			if (this.timerInterval) {
				clearInterval(this.timerInterval);
				this.timerInterval = null;
			}
		},
		preventBack(event) {
			if (localStorage.getItem("cvsStarted")) {
				history.pushState(null, null, location.href); // Push again to trap back nav
			}
		},
		beforeUnloadHandler(event) {
			if (localStorage.getItem("cvsStarted")) {
				event.preventDefault();
				event.returnValue = ""; // Required for Chrome
			}
		},
		unlockNavigation() {
			localStorage.removeItem("cvsStarted");
			window.removeEventListener("popstate", this.preventBack);
			window.removeEventListener("beforeunload", this.beforeUnloadHandler);
			this.stopMicMuteCheckLoop();
		},
		destroyed() {
			clearInterval(this.timerInterval);
			// clearInterval(this.timerApiInterval);
			this.$store.commit("servicesVUEX/updateRemainingTimeInSeconds", 0);
			this.$store.commit("servicesVUEX/updateRemainingTime", "00:00");
		},
		startVerification() {
			if (this.$route.query.uuid) {
				localStorage.setItem("timer", 600);
				sessionStorage.setItem(
					"verificationUUID",
					this.$route.query.uuid.substring(0, 36)
				);
				this.$router.push({
					name: "IdCapture",
					query: {
						type: "imageCapture",
					},
				});
			} else {
				this.errorModal(
					"Error",
					"Unable to verify link, Please contact your system administrator"
				);
			}
		},
		submitAnswer() {
			this.pauseTimer();
			EventBus.$emit("submit-answer");
		},
		async goToScreenRec() {
			try {
				const permissionStatus = await navigator.permissions.query({
					name: "microphone",
				});
				if (permissionStatus.state !== "granted") {
					// Permission not yet granted — mic flow handled elsewhere, just navigate
					this.navigateToScreenRec();
					return;
				}
				// Permission already granted — getUserMedia won't show any Chrome prompt
				const stream = await navigator.mediaDevices.getUserMedia({
					audio: true,
				});
				this.micStream = stream;
				const audioTrack = stream.getAudioTracks()[0];
				// Detect software mute (enabled=false) and hardware/keyboard mute (muted=true)
				if (audioTrack && (!audioTrack.enabled || audioTrack.muted)) {
					this.showMicMutedModal = true;
					return;
				}
			} catch (err) {
				console.warn("Mic check error:", err);
				// On any error, don't block the user — just navigate
			}
			this.navigateToScreenRec();
		},
		async unmuteAndContinue() {
			try {
				// Stop old stream and request a fresh one to get current hardware state
				if (this.micStream) {
					this.micStream.getTracks().forEach((t) => t.stop());
				}
				const freshStream = await navigator.mediaDevices.getUserMedia({
					audio: true,
				});
				this.micStream = freshStream;
				const audioTrack = freshStream.getAudioTracks()[0];

				if (audioTrack && (!audioTrack.enabled || audioTrack.muted)) {
					// Mic is STILL muted (hardware/keyboard mute not resolved yet)
					this.micMutedMessage =
						"Your microphone is still muted. Please press your keyboard mute key or unmute from system settings, then try again.";
					return; // Keep modal open
				}

				// Mic is now active
				this.micMutedMessage = "";
				this.showMicMutedModal = false;

				// If already on screenRec just dismiss modal; otherwise navigate there
				if (this.$route.query.type !== "screenRec") {
					this.navigateToScreenRec();
				}
			} catch (err) {
				console.warn("Mic re-check failed:", err);
				this.micMutedMessage =
					"Unable to access microphone. Please check your system permissions and unmute your mic.";
			}
		},
		startMicMuteCheckLoop() {
			this.stopMicMuteCheckLoop(); // clear any existing loop first
			this.micCheckInterval = setInterval(() => {
				this.checkMicMuteStatus();
			}, 10000);
		},
		stopMicMuteCheckLoop() {
			if (this.micCheckInterval) {
				clearInterval(this.micCheckInterval);
				this.micCheckInterval = null;
			}
		},
		async checkMicMuteStatus() {
			// Don't stack alerts if modal is already showing
			if (this.showMicMutedModal) return;
			try {
				const permissionStatus = await navigator.permissions.query({
					name: "microphone",
				});
				if (permissionStatus.state !== "granted") return;
				const stream = await navigator.mediaDevices.getUserMedia({
					audio: true,
				});
				const audioTrack = stream.getAudioTracks()[0];
				// Stop the temporary stream right away — only needed for the check
				stream.getTracks().forEach((t) => t.stop());
				if (audioTrack && (!audioTrack.enabled || audioTrack.muted)) {
					this.micMutedMessage = "";
					this.showMicMutedModal = true;
				}
			} catch (err) {
				console.warn("Periodic mic check error:", err);
			}
		},
		navigateToScreenRec() {
			clearInterval(this.timerInterval);
			// clearInterval(this.timerApiInterval);
			localStorage.setItem("timer", 600);
			localStorage.setItem("cvsStarted", true);
			this.$router.push({
				name: "IdCapture",
				query: {
					type: "screenRec",
				},
			});
		},
		async cvsPreChecking() {
			this.loadPreChecking = true;
			this.loader = true;
			try {
				const response = await cvsPreCheck(this.$route.query.uuid);
				if (response.status == 200) {
					console.log("changing route");
					this.isSubmitted = false;
					this.$router.push({
						path: this.$route.path,
						query: { uuid: this.$route.query.uuid },
					});
				}
			} catch (error) {
				this.$router.push({
					name: "CvsSubmitted",
					// query: {
					// 	type: "submitted",
					// },
				});
				throw new Error(error);
			} finally {
				this.loader = false;
				this.loadPreChecking = false;
			}
		},
		startTimer() {
			let timer = localStorage.getItem("timer");
			this.$store.commit("servicesVUEX/updateRemainingTimeInSeconds", timer);

			this.timerInterval = setInterval(() => {
				let time =
					("0" + (Math.floor(this.remainingTimeInSeconds / 60) % 60)).slice(
						-2
					) +
					":" +
					("0" + (this.remainingTimeInSeconds % 60)).slice(-2);

				let array = time.split(":");

				let seconds = Number(array[0]) * 60 + Number(array[1]);

				this.$store.commit(
					"servicesVUEX/updateRemainingTimeInSeconds",
					this.remainingTimeInSeconds
				);
				this.$store.commit("servicesVUEX/updateRemainingTime", time);
				localStorage.setItem("timer", seconds);

				if (this.remainingTimeInSeconds <= 0) {
					this.$store.commit("servicesVUEX/updateRemainingTimeInSeconds", 0);
					this.$store.commit("servicesVUEX/updateRemainingTime", "00:00");
					clearInterval(this.timerInterval);
					// clearInterval(this.timerApiInterval);
				}
			}, 1000);
			// this.timerApiInterval = setInterval(async () => {
			// 	await cvsPreCheck(sessionStorage.getItem("verificationUUID"));
			// }, 30000);
		},
	},
};
</script>

<style>
.text-blue.btn-secondary {
	color: #20639b !important;
}
#noRefreshModal .modal-content {
	height: 350px;
}
#noRefreshModal .modal-dialog {
	max-width: 570px;
}
</style>
